import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Client-side fallback for /install.
 *
 * The real handler is the Nitro route (server/routes/install.ts), which fires
 * `cli_install_requested` before redirecting to the install script. This file
 * only runs when the SPA router owns the navigation, and it used to redirect
 * straight to GitHub, which silently skipped that event.
 *
 * Sending the browser to /install.sh instead forces a full document load, which
 * NITRO_ROUTE_PATTERNS routes to the tracked server handler. The one extra hop
 * costs a redirect and buys us every install request in the funnel.
 *
 * `reloadDocument` MUST stay explicit. router-core only infers it when `href`
 * parses as an absolute URL (`new URL(href)` without a base); a relative href
 * throws there and is silently treated as an internal SPA destination. Since
 * /install.sh has no client route, dropping this flag does not just lose the
 * event, it strands the user on an unmatched route and never serves the
 * installer at all.
 */
export const Route = createFileRoute("/install")({
  beforeLoad: () => {
    throw redirect({
      href: "/install.sh",
      reloadDocument: true,
      statusCode: 302,
    });
  },
});
